module.exports = __webpack_public_path__ + "static/media/facebook.b3d1ec82.svg";